/**
 * PLATAFORMA — só o dono do sistema vê. Cria a conta de uma empresa nova e
 * convida o gestor dela; a partir daí o gestor cuida da própria equipe.
 */
import { useEffect, useState } from 'react'
import { api, Recusa, SemSinal } from '../dados/sessao'
import { dataBR } from '../dominio/numeros'
import { Campo, Dica, Janela, Tarja } from '../ui'
import { copiarLink } from './Equipe'

interface ContaDaPlataforma { id: string; nome_fantasia: string; plano: string; ativa: boolean; criada_em: string; pessoas: number; gestores: string | null }

function mensagemDe(e: unknown): string {
  if (e instanceof SemSinal) return 'Sem internet agora.'
  if (e instanceof Recusa) return e.message
  return 'Não deu para concluir. Tente de novo.'
}

export function Plataforma() {
  const [contas, setContas] = useState<ContaDaPlataforma[] | null>(null)
  const [erro, setErro] = useState('')
  const [nova, setNova] = useState<{ nome_fantasia: string; nome: string; email: string; sigla: string } | null>(null)
  const [indo, setIndo] = useState(false)
  const [ultimo, setUltimo] = useState<{ empresa: string; link: string; email: boolean } | null>(null)

  const carregar = () => api<{ contas: ContaDaPlataforma[] }>('plataforma/contas').then((r) => setContas(r.contas)).catch((e) => setErro(mensagemDe(e)))
  useEffect(() => { carregar() }, [])

  async function criar() {
    if (!nova) return
    setIndo(true)
    try {
      const r = await api<{ link: string; email_enviado: boolean }>('plataforma/contas', nova)
      setUltimo({ empresa: nova.nome_fantasia, link: r.link, email: r.email_enviado })
      setNova(null); carregar()
    } catch (e) { window.alert(mensagemDe(e)) } finally { setIndo(false) }
  }

  return (
    <div>
      <h2 className="secao">Plataforma — empresas no Pesagem</h2>
      {erro && <Tarja tipo="erro">{erro}</Tarja>}
      {ultimo && (
        <Tarja tipo="ok">
          {ultimo.empresa} criada. {ultimo.email ? 'O convite do gestor foi por e-mail.' : 'O e-mail NÃO saiu — mande o link pelo WhatsApp.'}{' '}
          <button className="mini" onClick={() => copiarLink(ultimo.link)}>Copiar link</button>
        </Tarja>
      )}
      <div className="cartao">
        {!contas ? <div className="vazio">Carregando…</div> : contas.map((c) => (
          <div key={c.id} className="item">
            <div className="item-topo"><span className="item-titulo">{c.nome_fantasia}</span><span className="mini-dica">{c.pessoas} pessoa{c.pessoas === 1 ? '' : 's'} · plano {c.plano}</span></div>
            <div className="item-baixo"><span>{c.gestores ?? 'sem gestor'}</span><span>desde {dataBR(c.criada_em)}</span></div>
          </div>
        ))}
        <button className="botao fantasma" onClick={() => setNova({ nome_fantasia: '', nome: '', email: '', sigla: '' })}>+ Nova empresa</button>
      </div>
      {nova && (
        <Janela titulo="Nova empresa" fechar={() => setNova(null)}>
          <Campo rotulo="Nome fantasia da empresa" valor={nova.nome_fantasia} mudar={(v) => setNova({ ...nova, nome_fantasia: v })} />
          <Campo rotulo="Nome do gestor" valor={nova.nome} mudar={(v) => setNova({ ...nova, nome: v })} />
          <Campo rotulo="E-mail do gestor (login)" tipo="email" valor={nova.email} mudar={(v) => setNova({ ...nova, email: v })} />
          <Campo rotulo="Sigla do gestor" valor={nova.sigla} mudar={(v) => setNova({ ...nova, sigla: v.toUpperCase() })} max={4} maiusculas />
          <Dica>A empresa nasce no plano cortesia. O gestor recebe o convite e, depois, cadastra a própria equipe.</Dica>
          <button className="botao" disabled={indo} onClick={criar}>{indo ? 'Criando…' : 'Criar empresa e convidar o gestor'}</button>
          <button className="botao fantasma" onClick={() => setNova(null)}>Fechar</button>
        </Janela>
      )}
    </div>
  )
}
